import { render, staticRenderFns } from "./CreateTariffModal.vue?vue&type=template&id=d62d9618&scoped=true"
import script from "./CreateTariffModal.vue?vue&type=script&lang=js"
export * from "./CreateTariffModal.vue?vue&type=script&lang=js"
import style0 from "./CreateTariffModal.vue?vue&type=style&index=0&id=d62d9618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62d9618",
  null
  
)

export default component.exports